class ShopAllPage extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector("[data-shop-all-grid]");
    this.empty = this.querySelector("[data-shop-all-empty]");
    this.showing = this.querySelector("[data-shop-all-showing]");
    this.sortSelect = this.querySelector("[data-shop-all-sort]");
    this.cards = [];
    this.activeFilter = "all";
    this.activeSort = "featured";
  }

  connectedCallback() {
    if (!this.grid) return;

    this.cards = Array.from(this.grid.querySelectorAll(".shop-all-card"));

    this.querySelectorAll("[data-shop-all-filter]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const filter = btn.dataset.shopAllFilter || "all";

        if (filter === "all" && this.activeFilter === "all") {
          return;
        }

        if (btn.getAttribute("aria-pressed") === "true") {
          return;
        }

        this.setFilter(filter);
      });
    });

    this.setFilter(this.activeFilter);

    this.sortSelect?.addEventListener("change", (e) => {
      this.activeSort = e.target.value;
      this.render();
    });

    this.grid.addEventListener("click", (e) => this.handleGridClick(e));

    this.querySelectorAll(".shop-all-card__quickadd").forEach((button) => {
      if (!button.dataset.defaultHtml) {
        button.dataset.defaultHtml = button.innerHTML.trim();
      }
    });
  }

  handleGridClick(e) {
    const quickAdd = e.target.closest(".shop-all-card__quickadd");
    if (quickAdd) {
      e.preventDefault();
      this.addToCart(quickAdd);
    }
  }

  addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled || button.classList.contains("is-added")) {
      return;
    }

    const cart = document.querySelector("cart-drawer");
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");

    if (cart && typeof cart.getSectionsToRender === "function") {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id),
      );
    }
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    button.disabled = true;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.disabled = false;
          return;
        }

        button.classList.add("is-added");
        const label = button.dataset.addedLabel || "Added";
        button.innerHTML = `<span aria-hidden="true">✓</span> ${label}`;

        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "shop-all",
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && cart.dataset?.cartType !== "page") {
          cart.renderContents(response, true);
        }

        setTimeout(() => {
          button.classList.remove("is-added");
          button.disabled = false;
          button.innerHTML = button.dataset.defaultHtml || button.innerHTML;
        }, 1400);
      })
      .catch(() => {
        button.disabled = false;
      });
  }

  setFilter(filter) {
    this.activeFilter = filter;

    this.querySelectorAll("[data-shop-all-filter]").forEach((el) => {
      const isActive = (el.dataset.shopAllFilter || "all") === filter;
      el.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    this.render();
  }

  getVisibleCards() {
    let list = this.cards.slice();

    if (this.activeFilter !== "all") {
      list = list.filter(
        (card) => card.dataset.cat === this.activeFilter,
      );
    }

    if (this.activeSort === "price-asc") {
      list.sort(
        (a, b) =>
          Number(a.dataset.price) - Number(b.dataset.price),
      );
    } else if (this.activeSort === "price-desc") {
      list.sort(
        (a, b) =>
          Number(b.dataset.price) - Number(a.dataset.price),
      );
    } else if (this.activeSort === "name") {
      list.sort((a, b) =>
        (a.dataset.name || "").localeCompare(b.dataset.name || ""),
      );
    } else {
      list.sort(
        (a, b) =>
          Number(a.dataset.featured) - Number(b.dataset.featured),
      );
    }

    return list;
  }

  render() {
    const visible = this.getVisibleCards();
    const visibleSet = new Set(visible);

    this.cards.forEach((card) => {
      card.classList.toggle("is-hidden", !visibleSet.has(card));
    });

    visible.forEach((card) => {
      this.grid.appendChild(card);
    });

    if (this.showing) {
      this.showing.textContent = String(visible.length);
    }

    if (this.empty) {
      this.empty.classList.toggle("is-visible", visible.length === 0);
    }

    if (this.grid) {
      this.grid.style.display = visible.length === 0 ? "none" : "grid";
    }
  }
}

if (!customElements.get("shop-all-page")) {
  customElements.define("shop-all-page", ShopAllPage);
}
